<template>
  <div class="footer section" :class="gray">
    <div class="container">
      <div class="row">
        <div class="col-md-4 order-3 order-md-0">
          <div class="footer__title">
            <template v-if="siteParams">
              {{ siteParams.siteName }}
            </template>
          </div>
          <p>
            <template v-if="siteParams">
              {{ siteParams.shortDescription }}
              <br />&copy; {{ siteParams.copyYear }}
            </template>
          </p>
          <p>
            <router-link to="/privacy">Политика конфиденциальности</router-link>
          </p>
        </div>
        <div class="col-md-4">
          <h3 class="footer__title">Страницы</h3>

          <ul class="f-list">
            <li class="f-list__item">
              <router-link to="/students">Студентам</router-link>
            </li>
            <li class="f-list__item">
              <router-link to="/about">О нас</router-link>
            </li>
            <li class="f-list__item">
              <router-link to="/error-report">
                Сообщить об ошибке на сайте
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <h3 class="footer__title">Контакты</h3>

          <ul class="f-list">
            <template v-if="siteParams">
              <li class="f-list__item">
                <a :href="'mailto:' + siteParams.infoEmail">
                  {{ siteParams.infoEmail }}
                </a>
              </li>
              <li class="f-list__item">
                <a :href="'tel:' + siteParams.phoneNonFormat">
                  {{ siteParams.phone }}
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gray: {
      type: String,
      default: ''
    }
  },
  computed: {
    siteParams() {
      return this.$store.getters.getSiteParams;
    }
  }
};
</script>
